import { render, staticRenderFns } from "./faqChildren.vue?vue&type=template&id=3b81a240"
import script from "./faqChildren.vue?vue&type=script&lang=js"
export * from "./faqChildren.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports